import React from 'react'

export const Footer = () => {
    return  <div className="container">
    <div className="row vertical-offset-lg" ></div>
    <div className="row xs-hide">
        <div className='col-md-6' style={{height:'25px'}}>
            <div style={{display:'inline', verticalAlign:'bottom', height:'25px'}}>The bond resource center is powered by</div>
            <img alt="tradeweb" aria-hidden={true} src="./resources/images/tradeweb-logo.svg" />
        </div>
        <div className='col-md-6' style={{height:'25px'}}>
            <div style={{position:'absolute', right:0, bottom:0}}>All data provided by Tradeweb Markets LLC unless otherwise noted.</div>
        </div>
    </div>
    <div className="row xs-show">
        <div className='col-xs-12 text-center'>
            <div>The bond resource</div>
            <div>center is powered by</div>
            <div className="vertical-offset-lg"><img alt="tradeweb" aria-hidden={true} src="./resources/images/tradeweb-logo.svg" /></div>

            <div>All data provided by Tradeweb Market</div>
            <div>LLC unless otherwise noted.</div>
        </div>
    </div>
    <div className="row vertical-offset-lg" ></div>
    </div>
}